import React from 'react';

interface IProps {
  listImage: string;
  movie: number;
}

const ListImage = (props: IProps) => (
  <div className="list-image-box">
    <img
      role="presentation"
      className="list-image"
      src={`data:image/jpeg;base64,${props.listImage}`}
    />
    <div className={props.movie ? 'movie-icon' : ''} />
  </div>
);

export default ListImage;
